/** @namespace Data */
NS("Data");

/**
 * Class for blocking item state. use as mixin
 * @class
 */
Data.TransactionItem = Class({
    /**
     * @private
     * @type {*} backup of original item
     */
    transactionItem_: null,
    /**
     * @protected
     * @type {string} original item property
     */
    transactionItemProp: "item",
    /**
     * @param {*} [item]
     * @returns {Data.TransactionItem}
     */
    commitItem(item) {
        item || (item = this[this.transactionItemProp || "item"]);

        this.transactionItem_ = deepClone(item);

        return this;
    },
    /**
     * @returns {Data.TransactionItem}
     */
    rollbackItem() {
        _.extend(this[this.transactionItemProp || "item"], deepClone(this.transactionItem_));

        return this;
    }
});

function deepClone(obj) {
    var i, ret, ret2;
    if (typeof obj === "object") {
        if (obj === null) {
            return obj;
        }
        if (Object.prototype.toString.call(obj) === "[object Array]") {
            ret = [];
            for (i = 0; i < obj.length; i++) {
                if (typeof obj[i] === "object") {
                    ret2 = deepClone(obj[i]);
                } else {
                    ret2 = obj[i];
                }
                ret.push(ret2);
            }
        } else {
            ret = {};
            for (i in obj) {
                if (obj.hasOwnProperty(i)) {
                    if (typeof(obj[i] === "object")) {
                        ret2 = deepClone(obj[i]);
                    } else {
                        ret2 = obj[i];
                    }
                    ret[i] = ret2;
                }
            }
        }
    } else {
        ret = obj;
    }

    return ret;
}
